export const   listingFlagged= 'FLAG-LISTING'
export const   userFLagged= 'FLAG-USER'
export const   flagsSet= 'SET-FLAGS'
export const   flagsReset= 'RESET-FLAGS'
export const   openFlag= 'OPEN-FLAG-MODAL'
export const   closeFlag= 'CLOSE-FLAG-MODAL'
